import { API } from '@utils/axios'

export async function fetchCustomerList (params: any) {
  const response = await API.get('/CustomerManagement/List', { params })
  return response.data
}

export async function updateCustomer (data: any) {
  const response = await API.post('/CustomerManagement/UpdateInfo', data)
  return response.data
}

export async function fetchUserPoints (params: any) {
  const response = await API.get('/CustomerPoint/search', { params })
  return response.data
}

export async function addPoints (data: any) {
  const response = await API.post('CustomerPoint/Create', data)
  return response.data
}

export async function fetchUserReports (params: any) {
  const response = await API.get('CustomerManagement/ReportList', { params })
  return response.data
}

export async function confirmReport (data: any) {
  const response = await API.post('CustomerManagement/ConfirmReport', data)
  return response.data
}

export async function getCreatorTypes () {
  const response = await API.get('/CustomerManagement/CreatorTypeList')
  return response.data
}

export async function createCreatorType (data: any) {
  const response = await API.post('/CustomerManagement/CreateCreatorType', data)
  return response.data
}

export async function updateCreatorType (data: any) {
  const response = await API.post('/CustomerManagement/UpdateCreatorType', data)
  return response.data
}

export async function downloadCustomers (params: any) {
  const response = await API.get('/CustomerManagement/Download', { params, responseType: 'blob' })
  return response.data
}

export async function uploadCustomerCreatorTypes (data: any) {
  const response = await API.post('/CustomerManagement/UploadCreatorType', data, { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'blob' })
  return response.data
}

export async function setCustomerCreatorType (data: any) {
  const response = await API.post('/CustomerManagement/SetCreatorType', data)
  return response.data
}

export async function getCustomerCreatorTypeHistory (params: any) {
  const response = await API.get('/CustomerManagement/CreatorTypeHistoryList', { params })
  return response.data
}

export async function deleteCreatorType (data: any) {
  const response = await API.post('/CustomerManagement/DeleteCreatorType', data)
  return response.data
}
